import styled from 'styled-components'
import { media } from '../../layouts/utils'
import {
  borderRadius,
  colorBrandPrimary,
  colorNeutral, colorNeutralDark,
  fontFamily,
  shadow,
} from '../../global.style'

export const ContainerCard = styled.div`
    width: 100%;
    max-width: ${(props) => (props.menor ? '308px' : '')};
    flex-direction: column;
    background-color: ${(props) =>
        props.transparent ? 'transparent' : colorNeutral.light};
    border-radius: ${borderRadius.md};
    box-sizing: border-box;
    box-shadow: ${(props) => (props.usarBorda ? shadow.level1 : `none`)};
    display: flex;
    padding: 0px 29px;
    padding-bottom: ${(props) => (props.usarBorda ? '32px' : '0')};
    align-items: ${(props) =>
        props.alinhamento === 'Início'
            ? `start`
            : props.alinhamento === 'Fim'
            ? `end`
            : `center`};

    &:hover {
        box-shadow: ${(props) => (props.usarBorda ? shadow.level2 : `none`)};
    }

    img {
        margin-top: ${(props) => (props.especial ? '-110px' : '0px')};
        min-height: ${(props) => (props.sizeCardImage ? `${props.sizeCardImage}px` : '258px')};
        width: ${(props) => (props.sizeCardImage ? `${props.sizeCardImage}px` : '258px')};
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: 20px;
        align-self: ${({ tabCard }) => (tabCard ? 'flex-start;' : '')};
    }

    ${media.large`
        max-width: initial;

        img {
            width: 184px;
            min-height: 184px;
            margin-top: 24px;
        }
    `}

    ${media.phone`
        align-items: center;
        padding: 24px;
        img {
            align-self: center;
            margin-left: 0
        }
    `}
`
export const ContainerText = styled.div`
    width: 100%;
    max-width: 260px;
    height: fit-content;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: ${(props) =>
        props.alinhamento === 'Início'
            ? `start`
            : props.alinhamento === 'Fim'
            ? `end`
            : `center`};
    justify-content: space-between;

    ${media.phone`
        align-items: center;
    `}

    ${media.smallPhone`
      min-height: 50px;
    `}
`
export const TituloCard = styled.span`
    color: ${props => props.corTexto ? props.corTexto : colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: ${(props) => (props.blog ? '20px' : '24px')};
    letter-spacing: 0;
    line-height: ${(props) => (props.blog ? '22px' : '31.2px')};
    margin-bottom: ${(props) => (props.blog ? '20px' : '0')};
    min-height: 24px;

    ${media.large`
        font-size: 22px;
        line-height: 24px;
        margin-bottom: 14px;
    `}
`

export const TextoCard = styled.span`
    color: ${props => props.corTexto ? props.corTexto : colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    align-self: ${(props) =>
        props.alinhamento === 'Centro'
            ? `center`
            : props.alinhamento === 'Fim'
            ? `end`
            : `start`};
    text-align: ${(props) =>
        props.alinhamento === 'Centro'
            ? `center`
            : props.alinhamento === 'Fim'
            ? `end`
            : `start`};
    code {
        align-self: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        font-family: ${fontFamily.neutral};
        font-size: 14px;
        line-height: 21px;
    }

    p {
        color: ${(props) => props.corTexto ? props.corTexto.cor : colorNeutralDark['90'] };
        align-self: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        ${({ ellipsis }) =>
            ellipsis &&
            `
        display: -webkit-box;
        max-width: 100%;
        margin: 0 auto;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

  `};
    }
    h2 {
        align-self: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        font-family: ${fontFamily.brand};
        font-size: 24px;
        line-height: 26px;
        font-weight: normal;
        padding-bottom: 16px;
    }
    h3 {
        align-self: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        font-family: ${fontFamily.brand};
        font-size: 24px;
        font-weight: normal;
        padding-bottom: 16px;
    }
    h4 {
        align-self: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${(props) =>
            props.alinhamento === 'Centro'
                ? `center`
                : props.alinhamento === 'Fim'
                ? `end`
                : `start`};
        font-family: ${fontFamily.brand};
        font-size: 20px;
        font-weight: normal;
        padding-bottom: 16px;
    }

    ${media.phone`
        h2{
            font-size: 20px;
        }
    `}
`

export const Anotacao = styled.span`
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 10px;
    min-height: 100px;
    max-width: 268px;
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: ${(props) =>
        props.alinhamento === 'Centro'
            ? `center`
            : props.alinhamento === 'Fim'
            ? `end`
            : `start`};
`

export const SpacerCards = styled.div`
    margin-left: 20px;
`

export const CardChips = styled.div`
    margin: 0 0 10px 0;
    align-self: start;
    white-space: nowrap;

    ${media.large`
        width: auto;
    `}
`

export const CardLink = styled.div`
    margin-top: 8px;
    a {
        text-decoration: none;
    }
`

export const CtaContainer = styled.div`
    margin-top: 14px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: ${(props) =>
        props.alinhamento === 'Início'
            ? `flex-start`
            : props.alinhamento === 'Fim'
            ? `flex-end`
            : `center`};
    align-items: center;
`
